<script>
import AkButtonActionV2 from '@components/v2/general/AkButtonActionV2.vue';
import {PerfectScrollbar} from 'vue3-perfect-scrollbar';
import Checkbox from 'primevue/checkbox';

export default {
  name: 'GaBaseExpandedFilter',
  components: {PerfectScrollbar, AkButtonActionV2, Checkbox},
  props: {
    title: {
      type: String,
      required: true,
    },
    nbSelected: {
      type: Number,
      required: false,
      default: 0,
    },
    canGoBack: {
      type: Boolean,
      required: false,
      default: true,
    },
    showSelectAll: {
      type: Boolean,
      required: false,
      default: false,
    },
    optionsCount: {
      type: Number,
      required: false,
      default: 0,
    },
  },
  emits: ['back', 'reset', 'apply', 'toggle-select-all'],
  computed: {
    applyLabel() {
      if (!this.canGoBack) return 'Appliquer';
      if (!this.nbSelected) return 'Valider';
      return `Valider (${this.nbSelected})`;
    },
    allSelected() {
      return this.optionsCount > 0 && this.nbSelected === this.optionsCount;
    },
  },
};
</script>

<template>
  <div
    class="px-8 py-6 flex sticky border-grey-100 border-b gap-3 items-center h-[86px]"
    :class="{'justify-between': !canGoBack}">
    <button v-if="canGoBack" @click="$emit('back')" class="p-2 rounded-md border border-grey-100 text-grey-900">
      <i class="ga-icon ga-chevron_left text-lg" />
    </button>
    <span class="text-[18px] font-semibold text-grey-900">
      {{ title }}
    </span>
    <button v-if="!canGoBack" @click="$emit('back')">
      <i class="ga-icon ga-supprimer text-3xl text-grey-900" />
    </button>
  </div>
  <div v-if="showSelectAll" class="px-8 py-3 border-b border-grey-100">
    <label class="gap-3 flex py-1 items-center cursor-pointer">
      <checkbox
        :model-value="allSelected"
        binary
        @update:model-value="$emit('toggle-select-all')"
        class="[&_.p-checkbox-box]:!border-grey [&_.p-checkbox-box]:border [&_.p-checkbox-box]:rounded-6"
        :class="{'[&_.p-checkbox-box]:!bg-primary [&_.p-checkbox-box]:border-0': allSelected}" />
      <span class="font-medium text-grey-900 select-none">Tout sélectionner</span>
    </label>
  </div>
  <perfect-scrollbar :options="{suppressScrollX: true}" class="md:grow-0 grow">
    <slot name="default" />
  </perfect-scrollbar>
  <div class="border-t border-grey-100 px-8 py-6 flex gap-2">
    <AkButtonActionV2 label="Tout effacer" @click="$emit('reset')" class="font-medium btn-secondary !h-[48px] w-1/2" />
    <AkButtonActionV2 :label="applyLabel" @click="$emit('apply')" class="font-medium btn-primary !h-[48px] w-1/2" />
  </div>
</template>

<style scoped></style>
